// extracted by mini-css-extract-plugin
export var active = "avatar-module--active--aa26a";
export var activist = "avatar-module--activist--145ea";
export var athletic = "avatar-module--athletic--7c007";
export var avatarImage = "avatar-module--avatarImage--9b2af";
export var bookworm = "avatar-module--bookworm--eaad3";
export var chill = "avatar-module--chill--a50e6";
export var defaultAvatar = "avatar-module--defaultAvatar--1e350";
export var gamer = "avatar-module--gamer--a38e3";
export var glam = "avatar-module--glam--80e97";
export var hipster = "avatar-module--hipster--acee2";
export var prep = "avatar-module--prep--44e72";
export var root = "avatar-module--root--37ed0";
export var skater = "avatar-module--skater--15a99";
export var street = "avatar-module--street--0c936";